import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { withCookies, Cookies } from 'react-cookie';
import * as LogoutCallcenterUC from '../../../../usecases/logoutCallcenter/LogoutCallcenterUC';
import LoggedUser from '../../../loggedUser/LoggedUser';
import Logout from '../../../logout/Logout';
import EventEmitter from '../../../modules/event-emitter/EventEmitter';
import Listener from '../../../../const/Listener';
import PropTypes from 'prop-types';
import i18n from 'i18n-react';
import './HeaderCallcenter.css';
import LocalStorage from '../../../../const/LocalStorage';

const propTypes = {
  userAD: PropTypes.number,
  cookies: PropTypes.instanceOf(Cookies).isRequired,
  nameUserAD: PropTypes.string,
  role: PropTypes.string
};

const defaultProps = {
  userAD: null,
  nameUserAD: null,
  role: null
};

class HeaderCallcenter extends React.Component {
  constructor() {
    super();
    this.state = {
      isLogged: false
    };
  }

  componentDidMount() {
    this.setState({
      updateHeader: EventEmitter.createListener(Listener.UPDATE_HEADER, this.updateStateFromCookie)
    });
    this.updateStateFromCookie();
  }

  componentWillUnmount() {
    EventEmitter.removeListener(this.state.updateHeader);
  }

  updateStateFromCookie = () => {
    const dataCallcenterStorage = localStorage.getItem(LocalStorage.CUSTOMER_DATA_CALLCENTER);  
    const data = dataCallcenterStorage ? JSON.parse(dataCallcenterStorage) : null;      
    if (data) {
      this.setState({
        isLogged: true,
        name: data.firstName,
        tudoAzulNumber: data.username,
        points: data.pointsBalance
      });
    } else {
      this.setState({ isLogged: false });
    }
  };

  verifyRole() {
    return this.props.role === "SUPER" || this.props.role === "super";
  }

  render() {
    return (
      <header className="HeaderCallcenter padding-eight-horizontal-56">
        <div className="HeaderCallcenter__logo HeaderCallcenter__component">
          <a href="/" target="_self">
            <img src="styles/img/azul-logo-color@2x.png" width="120" alt="" />
          </a>
        </div>
        <div className="HeaderCallcenter__component">
          <div className={ this.verifyRole() ? 'UserMenuContainer_Super bg-blue' : 'UserMenuContainer bg-blue'}>
            <Row className="UserMenuContainer__noMargin">
              <Col xs={6} className="no-padding UserMenuWrapper">
                <Row className="UserMenuContainer__userInfoMenu">
                  <Col xs={12} className="no-padding">
                    <Row className="UserMenuContainer__noMargin">
                      <Col xs={12} className="no-padding">
                        <span data-test="attendantLabel">
                          {i18n.translate('components.userMenu.attendant').toString()}
                        </span>
                      </Col>
                      <Col xs={12} className="no-padding">
                        <Row className="UserMenuContainer__noMargin">
                          <Col xs={9} className="no-padding">
                            <span
                              className="UserMenuContainer__reLabel UserMenuContainer__re"
                              data-unit="reLabel"
                              data-test="reLabel">
                              {this.props.nameUserAD}
                            </span>
                          </Col>
                          <Col xs={3} className="no-padding">
                            <a
                              className="UserMenuContainer__logoutLink"
                              data-test="logoutLink"
                              data-unit="logoutLink"
                              onClick={this.logout}>
                              {i18n.translate('components.userMenu.logout').toString()}
                            </a>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col xs={6} className="no-padding UserMenuLinksWrapper">
                <Row className={this.verifyRole() ? 'UserMenuContainer__userMenuLinksSuper' : 'UserMenuContainer__userMenuLinks'}>
                  <Col xs={6} className="no-padding">
                    <a
                      className="text-white text-500 lh-lg UserMenuContainer__userMenuLinks__searchPnr"
                      data-test="pnrSearchLink"
                      data-unit="pnrSearchLink"
                      href={global.env.CALLCENTER_SEARCH_URL}>
                      {i18n.translate('components.userMenu.pnrSearch').toString()}
                    </a>
                  </Col>
                  <Col xs={6} className="no-padding">
                    <a
                      className="text-white lh-lg UserMenuContainer__userMenuLinks__searchFlights"
                      data-test="searchFlightsLink"
                      data-unit="searchFlightsLink"
                      href="/?callcenter=true">
                      <b>{i18n.translate('components.userMenu.searchFlights').toString()}</b>
                    </a>
                  </Col>
                  { this.verifyRole() ? 
                    <Col span={10}>
                        <a
                          className="text-white lh-lg UserMenuContainer__userMenuLinks__ranges"
                          data-test="ranges"
                          href={global.env.CALLCENTER_RANGES_URL}
                        >
                          {i18n.translate('components.userMenu.newRanges').toString()}
                        </a>
                    </Col>
								: null }
                </Row>
              </Col>
            </Row>
          </div>
        </div>
        <div className="login-header">{this.renderLoggedUser()}</div>
      </header>
    );
  }

  renderLoggedUser() {
    const { cookies } = this.props;
    if (this.state.isLogged) {
      return (
        <span data-unit="loggedUser">
          <LoggedUser
            id="loggedUser"
            name={this.state.name}
            tudoAzulNumber={this.state.tudoAzulNumber}
            points={this.state.points}
          />
          <Logout display={this.state.isLogged} cookies={cookies} callcenterMode={true} />
        </span>
      );
    }
  }

  logout() {
    LogoutCallcenterUC.execute();
  }
}

HeaderCallcenter.defaultProps = defaultProps;
HeaderCallcenter.propTypes = propTypes;

export default withCookies(HeaderCallcenter);



// WEBPACK FOOTER //
// ./src/components/header/headerContainer/headerCallcenter/HeaderCallcenter.jsx